import { connect } from 'react-redux';
import {intlShape, injectIntl, FormattedMessage} from 'react-intl';
import Input from '../../../ui/Input';
import React, { Component } from 'react';
import Form from "../../../ui/Form";
import {Field, reduxForm, getFormSubmitErrors} from "redux-form/immutable";
import Button from "../../../ui/Button";

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const { size, ...props } = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage
                        id={`addressbook.label.${props.label || props.input.name}`}
                    />
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.hint} />
                </Form.Hint>
            )}
            {props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

@injectIntl
export class ShareAddressbook extends Component {
  static propTypes = {
      intl: intlShape.isRequired,
  };

  render() {
      const { submitErrors, handleSubmit, submitting } = this.props;

      return (
          <Form onSubmit={handleSubmit}>
              <Field
                  component={renderField}
                  name='addressbook'
                  label={false}
                  required
                  type='hidden'
              />

              <Field
                  component={renderField}
                  label='email'
                  name='email'
                  required
                  type='email'
                  error={submitErrors && submitErrors.get('email')}
              />

              <br />
              <Button emphasis='primary' type='submit' block disabled={submitting}>
                  <FormattedMessage id='addressbook.button.invite' />
              </Button>
          </Form>
      );
  }
}

let FormComponent = reduxForm({
    form: 'addressbook_share',
})(ShareAddressbook);

FormComponent = connect(state => ({
    submitErrors: getFormSubmitErrors('addressbook_share')(state),
}))(FormComponent);

// See https://github.com/erikras/redux-form/issues/1010
export default {
    Component: FormComponent,
};
